import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryOverview() {
  return (
    <section className="py-16 md:py-20 bg-background-50" aria-labelledby="category-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-50 text-primary-700 text-xs font-medium rounded-full mb-4">
            蔬菜分类
          </span>
          <h3 id="category-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选六大品类
          </h3>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            从叶菜到根茎，从茄果到菌菇，新有菜覆盖日常餐桌所需全部蔬菜品类
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/categories`}
              className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
              style={{ animation: `slideUp 400ms ease-out ${index * 80}ms both` }}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 text-center">
                <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors">
                  {cat.name}
                </h4>
                <p className="text-xs text-foreground-400 mt-0.5">{cat.productCount}款产品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}